<section class="container">
<div class="left-card">
  <div class="text-center">
    <img
      class="profile-img"
      src="https://imgv3.fotor.com/images/blog-cover-image/10-profile-picture-ideas-to-make-you-stand-out.jpg"
    />
    <h4 class="mt-2">{{ userInfo.name }}</h4>
  </div>
  <hr />
  <ul>
    <li
      [routerLink]="'/' + lang + '/profile/myCourses'"
      routerLinkActive="active"
    >
      <a>{{ "My Courses" | translate }}</a>
    </li>
    <li
      [routerLink]="'/' + lang + '/profile/payments'"
      routerLinkActive="active"
    >
      <a>{{ "My Payments" | translate }}</a>
    </li>
    <li
      [routerLink]="'/' + lang + '/profile/reset-password'"
      routerLinkActive="active"
    >
      <a>{{ "Reset Password" | translate }}</a>
    </li>
    <li (click)="logout()">
      <a>{{ "Logout" | translate }}</a>
    </li>
  </ul>
</div>
</section>